import { IBranch, UserAccess } from '../users/models'
import { IBranchDto, IWhitelabelDto } from './dtos'
import { IWhitelabel } from './models'

export function mapBranchFromDto(branchDto: IBranchDto): IBranch {
	const { id, axCustomerId, name, permissions, country, settings, IsoCode, contactPersonId } = branchDto

	return {
		id,
		axCustomerId,
		name,
		access: permissions?.admin ? UserAccess.Admin : UserAccess.Regular,
		countryCode: country,
		useUpperCase: settings?.enforceUpperCaseReference,
		endUserInvoicing: settings?.endUserInvoicing,
		businessInvoicing: settings?.businessInvoicing,
		maxImageUploaded: settings?.maxImageUpload,
		contactPersonId,
		locale: IsoCode,
		_dto: branchDto,
	}
}

export function mapBranchToDto({ name, access, locale, _dto }: IBranch): IBranchDto {
	return {
		..._dto,
		name,
		IsoCode: locale,
		permissions: {
			admin: access === UserAccess.Admin,
		},
	}
}

export function mapWhitelabelSettingsFromDto({
	logoUrl,
	primaryColor,
	primaryColorComplementaryTextColor,
	pageBackgroundColor,
	faviconUrl,
}: IWhitelabelDto): IWhitelabel {
	return {
		logoUrl,
		primaryColor,
		contrastColor: primaryColorComplementaryTextColor,
		pageBackgroundColor,
		faviconUrl,
	}
}
